export default __webpack_public_path__ + "static/media/to_delete1.b64de509.png";